









































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class';
import { FormRowWings, SelectWings } from '@/components';
import { SmsTextInputWings } from '@/components/SMS';
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { MsgTransports } from '@/store/types';
import { PushTemplateItemImpl } from '@/store/templates/types';
// import { PartnerItem } from '@/store/settings/partners/types';
import { PushApplicationItem } from '@/store/push/application/types';
import TemplateInputWings from "@/components/Inputs/TemplateInputWings.vue";
import {cloneDeep} from "lodash";
import {notifyError} from '@/utils/notify-helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
    TemplateInputWings,
    GenericTemplate,
    FormRowWings,
    SelectWings,
    SmsTextInputWings
}})
export default class PushTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Getter("pushApplications") applicationsList: any;
  @Getter("applicationAttributes") applicationAttributesList: any;

  @Action("getPushApplications") actionGetApplications: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;

  private transport: MsgTransports = MsgTransports.PUSH;
  private templateObject: PushTemplateItemImpl = new PushTemplateItemImpl();

  created() {
    this.setTemplate()
    try {
      this.actionGetApplications()
    } catch(error) {
      notifyError(error);
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }

  // async onTemplateChangePartner(partner:PartnerItem) {
  //   const appId: number = this.genericTemplate?.template.applicationId;
  //   this.genericTemplate.template.applicationId = null;
  //   if (partner){
  //     await this.actionGetApplications({partner:partner.name});
  //     if (this.applicationsList.some((app: PushApplicationItem) => app.id === appId))
  //       this.genericTemplate.template.applicationId = appId;
  //   }
  // }

  onChangeApplicationId() {
    if (this.genericTemplate.template.applicationId) {
      try {
        this.actionGetApplicationAttributes({applicationId: this.genericTemplate.template.applicationId})
      } catch(error) {
        notifyError(error);
      }
    }
  }
}
